import { useEffect } from 'react';
import Service from 'additiv-services';

export const useCancelAllRequests = () => {
    useEffect(() => () => {
        Service.cancelAll();
    }, []);
};
